import { useState } from "react";
import { User } from "../../types/User";
import { Option as TypeAheadOption } from "react-bootstrap-typeahead/types/types";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useUserService } from "../../hooks";

interface UserSearchOptions {
  isLoading: boolean;
  options: User[];
}

interface UserSearchProps {
  onUserClear: () => void;
  onUserSelect: (selected: User) => void;
  selectedUser?: User;
}
const UserSearch = ({
  onUserClear,
  onUserSelect,
  selectedUser,
}: UserSearchProps) => {
  const [userSearchOptions, setUserSearchOptions] = useState<UserSearchOptions>(
    {
      isLoading: false,
      options: [],
    },
  );
  const userService = useUserService();

  const onUserSearch = (searchTerm: string) => {
    if (!searchTerm) {
      setUserSearchOptions({ ...userSearchOptions, options: [] });
      return;
    }
    setUserSearchOptions({ ...userSearchOptions, isLoading: true });
    userService
      .search(searchTerm)
      .then((res: User[]) => {
        setUserSearchOptions({
          isLoading: false,
          options: res,
        });
      })
      .catch(() => {
        setUserSearchOptions({
          isLoading: false,
          options: [],
        });
      });
  };

  const onClear = (input: string) => {
    if (!input) {
      /// will need to clear user. then parent will need to clear filter
      onUserClear();
    }
  };

  /// this is the callback when the user selects a user from the typeahead
  const onSelect = (selected: TypeAheadOption[]) => {
    if (selected.length < 1) return;
    const selectedUser = selected[0] as User;
    onUserSelect(selectedUser);
  };

  return (
    <AsyncTypeahead
      id="userTypeahead"
      className="w-100"
      labelKey={(option: any) =>
        `${option.firstName} ${option.lastName} -  ${option.username}`
      }
      isLoading={userSearchOptions.isLoading}
      onSearch={onUserSearch}
      onChange={onSelect}
      onInputChange={onClear}
      clearButton
      options={userSearchOptions.options}
      selected={selectedUser ? [selectedUser] : []}
    />
  );
};

export default UserSearch;
